export const normalizeAnamneseFieldText = (value = '') =>
  String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

export const isAddressQuestion = (question = {}) => {
  const questionId = String(
    question?.id ||
    question?.key ||
    question?.question_id ||
    ''
  ).toLowerCase();

  const questionText = normalizeAnamneseFieldText(
    question?.question_text ||
    question?.label ||
    question?.question ||
    ''
  );

  if (
    question?.semantic_type === 'address' ||
    question?.field_type === 'address'
  ) {
    return true;
  }

  if (questionId === 'q_endereco') {
    return true;
  }

  return (
    questionText.includes('endereco') ||
    questionText.includes('logradouro')
  );
};